export function initCollapseContent() {
    const toggleButtons = document.querySelectorAll('[data-toggle="collapse"]');
    toggleButtons?.forEach(toggleButton => {
        const blockId = toggleButton.getAttribute('data-block-id') || toggleButton.getAttribute('data-index');
        const collapsedWrapper = document.querySelector(`#collapsedContent-${blockId}`)?.parentElement
            || document.querySelector(`#collapsedRepeaterContent-${blockId}`)?.parentElement;
        toggleButton.addEventListener('click', () => {
            collapsedWrapper.classList.toggle('expanded');
            toggleButton.textContent = collapsedWrapper.classList.contains('expanded')
                ? toggleButton.getAttribute('data-block-id')
                    ? __('Zwiń tekst')
                    : __('Czytaj mniej')
                : toggleButton.getAttribute('data-block-id')
                    ? __('Rozwiń tekst')
                    : __('Czytaj więcej');
        });
    });
}
